require('./bootstrap');

import Vue from 'vue'
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import Laraform from '@laraform/laraform/dist/essentials'
import BafoegRechnerForm from './components/forms/BafoegRechnerForm'
import de_DE from '../lang/de/de_DE'
import ButtonblockElement from './components/elements/ButtonblockElement'
import {BFormRadioGroup} from "bootstrap-vue/esm/components/form-radio";
Vue.component('b-form-radio-group', BFormRadioGroup)

Sentry.init({
    Vue,
    dsn: "https://907a37c634b84d90938e08b45818e8bd@o464506.ingest.sentry.io/5579207",
    autoSessionTracking: true,
    integrations: [
        new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

const German = require("flatpickr/dist/l10n/de.js").default.de;
flatpickr.localize(German);
Laraform.locale('de_DE', de_DE)

// BafögRechnerFormular registrieren
Vue.component('bafoegrechner-form', BafoegRechnerForm)

// neues Element
Laraform.element('buttonblock', ButtonblockElement)

Vue.use(Laraform)

const app = new Vue({
    el: '#app'
})
